query GetDafStatements($startDate: ISO8601Date!, $endDate: ISO8601Date!) {
  dafStatements(startDate: $startDate, endDate: $endDate) {
    id
    startDate
    endDate
    legalEntity
    currency
    giftAccountId
    generationStatus
    giftAccountName
    createdAt
    regeneratedOn
  }
}
